/**
 * Unicode-safe base64 encoding
 * Handles strings with characters outside the Latin1 range
 */ export var encodeBase64 = function (str) {
    try { // Convert the string to UTF-8 bytes, then encode to base64
        return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) { return String.fromCharCode(parseInt(p1, 16)); }));
    }
    catch (error) {
        console.error('Failed to encode base64:', error);
        throw new Error('Failed to encode data');
    }
}; /**
 * Unicode-safe base64 decoding
 * Handles strings with characters outside the Latin1 range
 */
export var decodeBase64 = function (str) {
    try { // Decode from base64, then convert UTF-8 bytes back to string
        return decodeURIComponent(Array.prototype.map.call(atob(str), function (c) { return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2); }).join(''));
    }
    catch (error) {
        console.error('Failed to decode base64:', error);
        throw new Error('Failed to decode data');
    }
};
